module.exports = __webpack_public_path__ + "static/media/ARFISS.2d556a74.jpg";